import "./Contact.scss";
import { useForm, SubmitHandler } from "react-hook-form";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";

const Contact = () => {
  const form = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
    shouldFocusError: false,
  });

  const onSubmit = (data) => {
    console.log(data);
    // reset();
    sendMail();
  };

  const sendMail = () => {
    // e.preventDefault();
    const userID = process.env.REACT_APP_PUBLIC_KEY;
    const serviceID = process.env.REACT_APP_SERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;

    // const template_param = {
    //   to_name: values.user_name,
    //   company: values.user_department,
    //   from_email: values.user_email,
    //   message: values.message,
    // };
    emailjs.sendForm(serviceID, templateID, form.current, userID).then(
      (result) => {
        console.log(result.text);
        console.log(form.current);
        window.alert(
          "送信完了致しました。\nお問い合わせ頂き有難うございました。"
        );
        window.location.reload();
      },
      (error) => {
        console.log(error.text);
      }
    );
  };

  const FormItem = [
    {
      name: "お名前",
      placeholder: "例）山田　太郎",
      status: "必須",
      color: { color: "#EF5858" },
      isCompleted: true,
    },
    {
      name: "メールアドレス",
      placeholder: "例）abc123@gmail.com",
      status: "必須",
      color: { color: "#EF5858" },
      isCompleted: true,
    },
    {
      name: "お問い合わせ",
      placeholder: "お問い合わせ内容",
      status: "必須",
      color: { color: "#EF5858" },
      isCompleted: true,
    },
  ];

  return (
    <div className="Contact-container-main">
      <div className="Contact-title">
        <h2 id="Contact" className="index">
          Contact
        </h2>
      </div>
      <div className="Contact-wrapper">
        <div className="contact_caption">
          <p>各種お問い合わせなどご気軽にご質問ください。</p>
          <p>なお土曜、日曜および祝日に頂いたお問い合わせは</p>
          <p>平日にご対応させていただきます。</p>
          <p> お待たせする場合があり大変申し訳ございませんが、</p>
          <p>何卒ご了承頂けると幸いです。</p>
        </div>
        <div className="contact_form">
          <form ref={form} onSubmit={handleSubmit(onSubmit)}>
            <div className="contact_form_name">
              <label htmlFor="name">{FormItem[0].name}</label>
              {errors.to_name?.type === "required" && (
                <span>入力してください。</span>
              )}
              {errors.to_name?.type === "maxLength" && (
                <span>10字以内で入力してください。</span>
              )}
            </div>
            <input
              name="to_name"
              {...register("to_name", {
                required: true,
                maxLength: 10,
              })}
              placeholder={FormItem[0].placeholder}
            />
            <div className="contact_form_name">
              <label htmlFor="adress">{FormItem[1].name}</label>
              {errors.from_email?.type === "required" && (
                <span>入力してください。</span>
              )}
              {errors.from_email?.type === "pattern" && (
                <span>メールアドレスの形式が不正です</span>
              )}
            </div>

            <input
              name="from_email"
              {...register("from_email", {
                required: true,
                maxLength: 60,
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                },
              })}
              placeholder={FormItem[1].placeholder}
            />

            <div className="contact_form_name">
              <label htmlFor="inquiry">{FormItem[2].name}</label>
              {errors.message?.type === "required" && (
                <span>入力してください。</span>
              )}
              {errors.message?.type === "maxLength" && (
                <span>300字以内で入力してください。</span>
              )}
            </div>

            <textarea
              name="message"
              {...register("message", {
                required: true,
                maxLength: 300,
              })}
              placeholder={FormItem[2].placeholder}
            />
            <div className="contact_fix">
              <div className="fix_button">
                {/* <button type="onsubmit">送信</button> */}
                <Button
                  type="onsubmit"
                  variant="contained"
                  endIcon={<SendIcon />}
                >
                  送信
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
